import { Autocomplete, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import { find, isEmpty, map } from 'es-toolkit/compat';
import { QCImpact } from 'interfaces/qcMarkers';

import React from 'react';
import { useQCImpacts } from 'utils/queryHooks/useQCMarkers';
import { useStainTypeIdToDisplayName } from 'utils/useStainTypeIdToDisplayName';
import ImpactIcon from './ImpactIcon';

interface QCMarkerSettingsTableProps {
  qcMarkers: string[];
  qcMarkersSettings: {
    [markerId: string]: string;
  };
  onMarkerValueChange: (markerId: string, value: string) => void;
}

const QCMarkerSettingsTable: React.FC<QCMarkerSettingsTableProps> = ({
  qcMarkers,
  qcMarkersSettings,
  onMarkerValueChange,
}) => {
  const { stainTypeIdToDisplayName } = useStainTypeIdToDisplayName();
  const { data: qcImpactOptions, isLoading } = useQCImpacts();

  return (
    <Paper variant="outlined" sx={{ mb: 1, overflow: 'hidden' }}>
      <Table size="small" sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow sx={{ bgcolor: 'action.hover' }}>
            <TableCell sx={{ width: '36%', fontWeight: 600 }}>Marker</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Cohort-Level Marker QC</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(qcMarkers, (markerId) => (
            <TableRow key={markerId}>
              <TableCell>{stainTypeIdToDisplayName(markerId)}</TableCell>
              <TableCell>
                <Autocomplete
                  options={qcImpactOptions || []}
                  loading={isLoading}
                  getOptionLabel={(option) => option.name}
                  value={
                    !isEmpty(qcMarkersSettings[markerId])
                      ? find(qcImpactOptions, (option: QCImpact) => option.id === qcMarkersSettings[markerId]) || {
                          id: qcMarkersSettings[markerId],
                          name: qcMarkersSettings[markerId],
                        }
                      : null
                  }
                  onChange={(event, newValue) => {
                    onMarkerValueChange(markerId, newValue?.id || '');
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Choose impact"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <ImpactIcon qcImpactId={qcMarkersSettings[markerId] || ''} emptyIconPlaceholder={true} />
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <ImpactIcon qcImpactId={option.id} />
                      {option.name}
                    </li>
                  )}
                  size="small"
                  fullWidth
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default QCMarkerSettingsTable;
